import React from 'react';
import { Link } from 'react-router-dom';
import ProductCard from '../components/ProductCard';
import { useWishlist } from '../context/WishlistContext';
import WishlistIcon from '../components/WishlistIcon';

export default function WishlistPage() {
  const { wishlistItems, loading, error } = useWishlist();

  if (loading) {
    return <main className="container py-5 text-center" role="status">Loading your wishlist…</main>;
  }

  return (
    <main className="container wishlist-page py-4 py-md-5">
      <header className="wishlist-page__header">
        <div>
          <p className="wishlist-page__kicker">Saved for later</p>
          <h1 className="brand-font">Your wishlist</h1>
          <p className="text-muted mb-0">Keep the handmade pieces you are considering close by.</p>
        </div>
        <strong>{wishlistItems.length} {wishlistItems.length === 1 ? 'piece' : 'pieces'}</strong>
      </header>

      {error && <div className="alert alert-danger" role="alert">{error}</div>}

      {wishlistItems.length === 0 ? (
        <section className="wishlist-empty" role="status">
          <div className="wishlist-empty__icon" aria-hidden="true"><WishlistIcon /></div>
          <h2 className="brand-font">Nothing saved yet</h2>
          <p>Tap the heart on any handmade piece to keep it here.</p>
          <Link to="/shop" className="btn btn-primary-custom rounded-pill">Explore the collection →</Link>
        </section>
      ) : (
        <div className="shop-products-grid wishlist-grid">
          {wishlistItems.map((product) => <ProductCard key={product.id} product={product} />)}
        </div>
      )}
    </main>
  );
}
